/** Must match server `consolePermissionMap.js` assignable keys (except superadmin). */

export const PLANNING_PAGE_KEYS = [
  "milestone_templates",
  "construction_timeline",
  "standard_resources",
  "standard_item_catalogue",
] as const;

export const INVENTORY_PAGE_KEYS = [
  "inventory_issue_po",
  "inventory_issue_material",
  "inventory_inward",
  "inventory_goods_receipts",
  "inventory_store_stocks",
  "inventory_stores_yards",
  "inventory_outward",
] as const;

export function canAnyPlanning(can: (p: string) => boolean): boolean {
  return PLANNING_PAGE_KEYS.some((k) => can(k));
}

export function canAnyInventory(can: (p: string) => boolean): boolean {
  return INVENTORY_PAGE_KEYS.some((k) => can(k));
}
